import { Duration, LocalDateTime, LocalTime } from "@js-joda/core";
import { serializable } from "serializr";
import { localDateTime } from "../serialization/MobxTypes";

/**
 *  DateTimeRange can be used to manipulate between two dates with time info.
 */
export class DateTimeRange {

   @serializable(localDateTime())
   readonly startDateTime: LocalDateTime;
   @serializable(localDateTime())
   readonly endDateTime: LocalDateTime;

   constructor (startDateTime: LocalDateTime = LocalDateTime.now(), endDateTime: LocalDateTime = startDateTime) {

      if (startDateTime === null || startDateTime === undefined) {
         throw Error('start date time must not be null or undefined');
      }

      if (endDateTime === null || endDateTime === undefined) {
         throw Error('end date time must not be null or undefined');
      }

      if (startDateTime.isAfter(endDateTime)) {
         throw Error('start date time must be after the end date time');
      }

      this.startDateTime = startDateTime;
      this.endDateTime = endDateTime;
   }

   static of(startDateTime: LocalDateTime, endDateTime: LocalDateTime = startDateTime): DateTimeRange {
      return new DateTimeRange(startDateTime, endDateTime);
   }

   contains(dateTime: LocalDateTime): boolean {
      return !this.startDateTime.isAfter(dateTime) && !this.endDateTime.isBefore(dateTime);
   }

   durationInFractionalHours(): number {
      return this.duration().seconds() / LocalTime.SECONDS_PER_HOUR;
   }

   duration(): Duration {
      return Duration.between(this.startDateTime, this.endDateTime);
   }

   overlapsInclusive(dateTimeRange: DateTimeRange): boolean {
      return !this.startDateTime.isAfter(dateTimeRange.endDateTime) && !this.endDateTime.isBefore(dateTimeRange.startDateTime);
   }
}
